/* unplugin-vue-components disabled */module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"pageTitle":"Онлайн-сервис для брокеров по продаже недвижимости по России - Страна Девелопмент","pageDescription":"Удобный инструмента от застройщика «Страна Девелопмент» для брокеров по продаже недвижимости в России. Сервис для риэлторов с личным кабинетом и программой лояльности."}}')
  delete Component.options._Ctor
}
